import { useForm } from "react-hook-form";
import { useSearchParams, useNavigate } from "react-router-dom";
import FormInputError from "components/General/FormInputError";
import { useTranslation } from "react-i18next";
import { AgentData } from "context/Agent/DataProvider";
import { useContext, useState } from "react";

const PolicyLookup = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { agentPolicies } = useContext(AgentData);
  const [errorType, setErrorType] = useState();
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      keyword: searchParams.get("keyword"),
    },
  });

  const searchPolicy = (data) => {
    let type = searchParams.get("type")
      ? searchParams.get("type").replaceAll(",", "%2C")
      : undefined;
    let paymentStatus = searchParams.get("paymentStatus")
      ? searchParams.get("paymentStatus").replaceAll(",", "%2C")
      : undefined;
    if (type && paymentStatus)
      navigate(
        `/policylookup?keyword=${data.keyword}&type=${type}&paymentStatus=${paymentStatus}`
      );
    else if (type && !paymentStatus)
      navigate(`/policylookup?keyword=${data.keyword}&type=${type}`);
    else if (!type && paymentStatus)
      navigate(
        `/policylookup?keyword=${data.keyword}&paymentStatus=${paymentStatus}`
      );
    else {
      let searchPolicy = agentPolicies?.filter(
        (x) =>
          x.oldPolicy?.includes(data?.keyword?.trim()) ||
          x.insuredFullName
            ?.toLowerCase()
            .replace(/\s+/g, "")
            .includes(data?.keyword?.toLowerCase().trim().replace(/\s+/g, ""))
      );
      if (!searchPolicy || searchPolicy?.length === 0) {
        //Error
        setErrorType("contractValidation");
        setError("keyword", {
          message: t("PolicyLookup-Contracts-not-found"),
        });
      } else {
        if (searchPolicy?.length === 1)
          navigate(`/policies/${searchPolicy[0]?.contractID}`);
        else navigate(`/book-of-business?keyword=${data.keyword}`);
      }
    }
  };

  return (
    <>
      <form
        className="flex flex-col sm:flex-row"
        onSubmit={handleSubmit(searchPolicy)}
      >
        <div className="flex flex-col flex-grow justify-start sm:mr-4">
          <div className="relative">
            <input
              id="id_policyLookupInput"
              className={`border border-ui-gray-medium h-9 w-full p-2 rounded ${
                errors?.keyword?.message ? "border-red-700" : ""
              } `}
              aria-label="Site Search"
              placeholder={t("AgentPolicyLookUp-enterpolicynumber")}
              {...register("keyword", {
                required: t("AgentPolicyLookUp-enterpolicynumber-or-lastname"),
              })}
            />
            {errors?.keyword?.message && errorType === "contractValidation" && (
              <span class="absolute inset-y-0 right-1 flex pr-4">
                <div class="ui-badge-icon-only ui-badge-problem">
                  <svg
                    class="ui-icon w-4 h-4"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-circle-solid-exclamation"></use>
                  </svg>
                </div>
              </span>
            )}
          </div>
          <FormInputError
            id="id_policyLookupError"
            errorMessage={errors?.keyword?.message}
            isOnlyText={errorType === "contractValidation" ? true : false}
          />
        </div>
        <div>
          <button
            id="id_policyLookupBtn"
            disabled={errors?.keyword?.message}
            className="ui-btn-primary h-9 w-32 mx-auto ui-btn-min-w mt-4 sm:mt-0"
          >
            {t("AgentPolicyLookup-serach-button")}
          </button>
        </div>
      </form>
    </>
  );
};

export default PolicyLookup;
